import type React from 'react';

import { DownloadIcon } from '@vlabs/icons';
import { IconButton } from '@vlabs/uikit/components/controls/button/icon-button';
import type { IconButtonProps } from '@vlabs/uikit/components/controls/button/icon-button';

import { downloadImage } from '@vlabs/monokit/shared/lib/images';

import type { DownloadImageProps } from './types';
import { buildTestid } from '../../../shared/lib/utils';

type DownloadImageIconButtonProps = DownloadImageProps & Omit<IconButtonProps, 'onClick'>;

const displayName = 'DownloadImageIconButton';
const testid = buildTestid(displayName);

function DownloadImageIconButton({
  url,
  'data-testid': dataTestId = undefined,
  ...props
}: DownloadImageIconButtonProps): React.JSX.Element {
  return (
    <IconButton
      icon={<DownloadIcon />}
      kind="secondary"
      onClick={() => downloadImage(url)}
      variant="flat"
      {...testid(dataTestId)}
      {...props}
    />
  );
}

DownloadImageIconButton.displayName = displayName;

export { DownloadImageIconButton };
